import { Fragment } from 'react';
import { getLabels } from '../constants/labels';
import { highlightRowClass, isHighlightedClass, stickyCellBg } from '../utils/classHighlight';

function formatDateHeader(isoDate) {
  const [, m, d] = isoDate.split('-').map(Number);
  const day = String(d).padStart(2, '0');
  const mon = String(m).padStart(2, '0');
  return `${day}/${mon}`;
}

export function MonthlyReportTable({
  report,
  labels: labelsProp,
  useMalayalam = false,
  highlightClassIds = [],
}) {
  const labels = labelsProp || getLabels(useMalayalam);
  if (!report?.rows?.length) {
    return null;
  }

  const { dates, rows, footer } = report;

  return (
    <div className="overflow-x-auto rounded-xl border border-border">
      <table className="w-full min-w-max text-sm">
        <thead>
          <tr className="border-b border-border bg-surface">
            <th className="sticky left-0 z-10 bg-surface px-3 py-2 text-left font-medium text-muted shadow-sticky">
              {labels.division}
            </th>
            {dates.map((d) => (
              <th key={d} colSpan={2} className="border-l border-border px-2 py-2 text-center font-medium text-muted">
                {formatDateHeader(d)}
              </th>
            ))}
            <th colSpan={2} className="border-l border-border px-2 py-2 text-center font-medium text-muted">
              {labels.rowTotal}
            </th>
            <th className="border-l border-border px-2 py-2 text-center font-medium text-muted">
              {labels.totalStudents}
            </th>
          </tr>
          <tr className="border-b border-border bg-surface/80">
            <th className="sticky left-0 z-10 bg-surface/80 px-3 py-1.5 shadow-sticky" />
            {dates.map((d) => (
              <Fragment key={`sub-${d}`}>
                <th className="border-l border-border px-2 py-1.5 text-center text-xs font-medium text-muted">
                  {labels.boys}
                </th>
                <th className="px-2 py-1.5 text-center text-xs font-medium text-muted">{labels.girls}</th>
              </Fragment>
            ))}
            <th className="border-l border-border px-2 py-1.5 text-center text-xs text-muted">{labels.boys}</th>
            <th className="px-2 py-1.5 text-center text-xs text-muted">{labels.girls}</th>
            <th className="border-l border-border px-2 py-1.5 text-center text-xs text-muted">Σ</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => {
            const highlighted = isHighlightedClass(row.class_id, highlightClassIds);
            return (
            <tr
              key={row.class_id}
              className={`border-b border-border hover:bg-surface/50 ${highlightRowClass(highlighted)}`}
            >
              <td
                className={`sticky left-0 z-10 px-3 py-2 font-medium text-text shadow-sticky ${stickyCellBg(highlighted)}`}
              >
                {row.division_name}
              </td>
              {dates.map((d) => {
                const cell = row.byDate?.[d] || { boys: 0, girls: 0 };
                return (
                  <Fragment key={`${row.class_id}-${d}`}>
                    <td className="border-l border-border px-2 py-2 text-center tabular-nums">{cell.boys}</td>
                    <td className="px-2 py-2 text-center tabular-nums">{cell.girls}</td>
                  </Fragment>
                );
              })}
              <td className="border-l border-border px-2 py-2 text-center font-medium tabular-nums">
                {row.rowTotalBoys}
              </td>
              <td className="px-2 py-2 text-center font-medium tabular-nums">{row.rowTotalGirls}</td>
              <td className="border-l border-border px-2 py-2 text-center font-semibold tabular-nums">
                {row.rowTotal}
              </td>
            </tr>
            );
          })}
          <tr className="bg-primary-light/40 font-semibold">
            <td className="sticky left-0 z-10 bg-primary-light/40 px-3 py-2 text-text shadow-sticky">
              {labels.grandTotal}
            </td>
            {dates.map((d) => {
              const cell = footer?.byDate?.[d] || { boys: 0, girls: 0 };
              return (
                <Fragment key={`ft-${d}`}>
                  <td className="border-l border-border px-2 py-2 text-center tabular-nums">{cell.boys}</td>
                  <td className="px-2 py-2 text-center tabular-nums">{cell.girls}</td>
                </Fragment>
              );
            })}
            <td className="border-l border-border px-2 py-2 text-center tabular-nums">{footer.grandTotalBoys}</td>
            <td className="px-2 py-2 text-center tabular-nums">{footer.grandTotalGirls}</td>
            <td className="border-l border-border px-2 py-2 text-center tabular-nums">{footer.grandTotal}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
